export namespace FileUtilities {
    // Function to download data to a file.
    // Reference: https://stackoverflow.com/questions/13405129/javascript-create-and-save-file
    // common values for type: 'text/plain', 'application/json', 'text/csv'
    export const saveFile = function(data: any, defaultFileName: string, type: string) {
        var file = new Blob([data], {type: type});
        var a = document.createElement("a");
        var url = URL.createObjectURL(file);
        a.href = url;
        a.download = defaultFileName;
        document.body.appendChild(a);
        a.click();
        setTimeout(function() {
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
        }, 0); 
    }
}